import ToastStatusGlobal from '@/components/toastStatusGlobal';
import { useState } from 'react';

export const useClipBoard = () => {
  const [isCopied, setIsCopied] = useState(false);
  const { toast } = ToastStatusGlobal();

  const copyToClipboard = async (text: string) => {
    try {
      const container = document.createElement('div');
      container.innerHTML = text;
      container.style.color = 'initial';
      container.style.position = 'fixed';
      container.style.pointerEvents = 'none';
      container.style.opacity = '0';
      document.body.appendChild(container);
      window.getSelection()?.removeAllRanges();
      const range = document.createRange();
      range.selectNode(container);
      window.getSelection()?.addRange(range);
      document.execCommand('copy'); //NOSONAR
      document.body.removeChild(container);

      setIsCopied(true);

      setTimeout(() => {
        setIsCopied(false);
      }, 2000);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Erro ao copiar para o clipboard';
      toast('Oops', errorMessage, 'error');
      setIsCopied(false);
      return false;
    }
  };

  return {
    isCopied,
    copyToClipboard,
  };
};
